import FromElsewhereComponent from './from-elsewhere';
export default class extends FromElsewhereComponent {}